/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import WayPoint from 'react-waypoint';
// import { history } from '../../../../../client'
/*
type FetchTriggerProps = {
  data: [ChannelModel],
  perPage: number,
  index: number,
  method: ([ChannelModel]) => {}
};
*/

/**
 * FetchTrigger (Component)
 *
 * When this component is reached in the view
 * it will trigger its onEnter method (fetchProgramsForChannelsIfNeeded)
 *
 * The methods receive the chunk of Array of channels that needs
 * it's programs to be displayed and potentially fetched
 *
 */

// eslint-disable-next-line react/prefer-stateless-function
class FetchTrigger extends React.PureComponent {
  render() {
    const { data, perPage, index, method } = this.props;

    if (index % perPage !== 0) return false;

    return (
      <WayPoint
        onEnter={() => {
          const slice = Object.values(data).slice(index, index + perPage);
          method(slice);
        }}
      />
    );
  }
}

FetchTrigger.displayName = 'FetchTrigger';

export default FetchTrigger;
